import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Forex.css";
import { FaCheck} from "react-icons/fa";

const Forex = () => {
    useEffect(() => {
        // Prevent duplicate script insertion
        if (document.querySelector("#tradingview-widget-script")) return;

        // Create script element
        const script = document.createElement("script");
        script.id = "tradingview-widget-script"; // Unique ID to prevent duplication
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
        script.async = true;
        script.innerHTML = JSON.stringify({
            "colorTheme": "light",
            "dateRange": "12M",
            "showChart": true,
            "locale": "en",
            "largeChartUrl": "",
            "isTransparent": false,
            "showSymbolLogo": true,
            "showFloatingTooltip": false,
            "width": "1000",
            "height": "550",
            "plotLineColorGrowing": "rgba(41, 98, 255, 1)",
            "plotLineColorFalling": "rgba(41, 98, 255, 1)",
            "gridLineColor": "rgba(240, 243, 250, 0)",
            "scaleFontColor": "rgba(19, 23, 34, 1)",
            "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
            "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
            "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
            "belowLineFillColorFallingBottom": "rgba(41, 98, 255, 0)",
            "symbolActiveColor": "rgba(41, 98, 255, 0.12)",
            "tabs": [
                {
                    "title": "Forex",
                    "symbols": [
                        { "s": "FX:EURUSD", "d": "EUR to USD" },
                        { "s": "FX:GBPUSD", "d": "GBP to USD" },
                        { "s": "FX:USDJPY", "d": "USD to JPY" },
                        { "s": "FX:USDCHF", "d": "USD to CHF" },
                        { "s": "FX:AUDUSD", "d": "AUD to USD" },
                        { "s": "FX:USDCAD", "d": "USD to CAD" }
                    ],
                    "originalTitle": "Forex"
                }
            ]
        });

        // Append script to the widget container
        document.querySelector(".tradingview-widget-container").appendChild(script);
    }, []);

    return (
        <>
            <Navbar />

            <div className="forex-section">
                <h2 className="forex-title">Forex</h2>
            </div>

            <div className="below-hero-section">
                <p>
                    Forex instruments are essential tools used in the foreign exchange market to facilitate trading.
                    They include currency pairs, which are the primary instrument, allowing traders to buy one currency
                    while simultaneously selling another. Other key instruments include forwards, futures, options,
                    and swaps, providing diverse strategies to manage risk and capitalize on currency movements.
                </p>
            </div>

            <div className="below-hero-section2">
                <h2>Trade Forex With Us</h2>
                {/* TradingView Widget */}
                <div className="widget-wrapper">
                    <div className="tradingview-widget-container">
                        <div className="tradingview-widget-container__widget"></div>
                        <div className="tradingview-widget-copyright">
                            <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank"></a>
                        </div>
                    </div>
                </div>
            </div>

 {/* Four-Column Section with Icons Aligned to the Right */}
             <div className="four-column-section">
                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>High leverage, tight spreads</h3>
                            
                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Advanced charting widgets</h3>
                            
                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Responsive, easy-to-use platforms</h3>
                            
                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Smart and friendly support, 5 days a week</h3>
                           
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Forex;
